/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const UNLIST_ASSET = gql`
mutation RemoveFromStore($tokenGroup: String!, $tokenId: String, $storeId: String) {
  removeFromStore(tokenGroup: $tokenGroup, tokenId: $tokenId, storeId: $storeId) {
    token_id
    token_group
    status
  }
}
`;

